import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import CompanySetup from './pages/CompanySetup';
import PrivacyPolicy from './components/Privacypolicy';
import DataProcessingAgreement from './components/DataProcessingAgreement';
import TermsOfService from './components/Termsofservice';
import AcceptableUse from './components/Acceptableuse';
import CookiePolicy from './components/Cookiepolicy';
import DeleteAccount from './components/DeleteAccount';
import AppHelp from './pages/AppHelp';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/app-help" element={<AppHelp />} />

          <Route 
            path="/company-setup" 
            element={
              <ProtectedRoute>
                <CompanySetup />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route path="/terms/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms/terms-of-service" element={<TermsOfService />} />
          <Route path="/terms/data-processing-agreement" element={<DataProcessingAgreement />} />
          <Route path="/terms/acceptable-use" element={<AcceptableUse />} />
          <Route path="/terms/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms/delete-account" element={<DeleteAccount />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;